import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, StaticContext } from "react-router";
import Description from "src/components/ConditionalRebates/Blocks/Description";
import DoneButton from "src/components/ConditionalRebates/Blocks/DoneButton";
import HandRaisers from "src/components/ConditionalRebates/Blocks/HandRaisers";
import ConditionalRebates from "src/components/ConditionalRebates/Blocks/ConditionalRebates";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import { ApplicationStore } from "src/store";
import "../ConditionalRebates.scss";

interface Props {
    closeDrawer?: () => void;
}

const DrawerView = ({
    isDataDriven,
    location: {
        state: { vin },
    },
}: Props & ReturnType<typeof mapStateToProps> & RouteComponentProps<{}, StaticContext, { vin: string }>) => {
    return (
        <DrawerWrapper title={`ConditionalRebates.Title`} translateTitle={true} vin={isDataDriven ? vin : undefined}>
            <Description isDataDriven={isDataDriven} />

            {isDataDriven ? <ConditionalRebates vin={vin} /> : <HandRaisers vin={vin} />}

            <DoneButton vin={vin} />
        </DrawerWrapper>
    );
};

const mapStateToProps = (state: ApplicationStore) => {
    return {
        isDataDriven: state.account.integration_settings?.Financing.conditional_rebates === "data-driven",
    };
};

export default connect(mapStateToProps)(DrawerView);
